/**
 * Fetch Yahoo user info (e.g. email) from backend. Backend uses cached Yahoo token.
 */
export const getYahooUserInfo = async (accessAuthToken: string): Promise<{ email: string | null }> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/get-yahoo-user-info`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessAuthToken}`,
    },
    credentials: "include",
  });
  if (!response.ok) {
    return { email: null };
  }
  const data = await response.json();
  return { email: data.email ?? null };
};
